import { UpdateServiceFieldMessage } from '@/@types/messages/UpdateServiceFieldMessage'
import { AppConfig } from '@/app.config'
import authenticatedFetch from '@/authenticatedFetch'
import { MiscellaneousService } from './miscellaneous.service'

export class ServiceFieldService {
  private appConfig: AppConfig
  private miscellaneousService: MiscellaneousService

  constructor(miscellaneousService: MiscellaneousService) {
    this.appConfig = new AppConfig()
    this.miscellaneousService = miscellaneousService
  }

  public deleteServiceField(id: number): Promise<void> {
    const requestOptions = {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' }
    }

    return authenticatedFetch(`${this.appConfig.sacServicesUrl}/v1/service-fields/${id}`, this.miscellaneousService, requestOptions).then(() => {
      return Promise.resolve()
    })
  }

  public updateServiceField(serviceFieldId: number, updateServiceFieldMessage: UpdateServiceFieldMessage): Promise<void> {
    const requestOptions = {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(updateServiceFieldMessage)
    }

    return authenticatedFetch(`${this.appConfig.sacServicesUrl}/v1/service-fields/${serviceFieldId}`, this.miscellaneousService, requestOptions).then(() => {
      return Promise.resolve()
    })
  }
}
